{
  "hero": {
    "eyebrow": "How it works",
    "title": "Contract renewable energy assets and receive",
    "highlight": "a share of recurring revenues and Guarantees of Origin.",
    "subtitle": "A guided, transparent process: from analysing your goals to obtaining a share of the revenues and Guarantees of Origin over many years"
  },
  "stats": {
    "peakPower": "Peak power",
    "expectedProduction": "Expected production"
  },
  "plants": {
    "parco-terra-5mw": {
      "name": "Ground-mounted solar park",
      "kind": "Agricultural land · Lombardy",
      "fit": "Fixed savings for ten years"
    },
    "tetto-industriale-1mw": {
      "name": "Industrial rooftop",
      "kind": "Agricultural land · Veneto",
      "fit": "Direct effect on EBITDA"
    },
    "agrivoltaico-2mw": {
      "name": "Agrivoltaic plant",
      "kind": "Agricultural land · Emilia-Romagna",
      "fit": "A story worth putting on the public profile"
    },
    "parco-terra-merchant": {
      "name": "Merchant ground-mounted park",
      "kind": "Agricultural land · Sicily",
      "fit": "Revenues that follow the energy price"
    },
    "portafoglio-eecs": {
      "name": "EECS-certified portfolio",
      "kind": "Three plants · Italy and Switzerland",
      "fit": "SBTi-compliant Guarantees of Origin"
    }
  },
  "model": {
    "steps": [
      {
        "k": "step 1 · the context",
        "t": "Tell us your company's goals, energy consumption and current tools.",
        "d": "In a preliminary phase, DEC Energy sets out to understand your company's financial and sustainability targets, the specifics of your energy consumption and the tools you use."
      },
      {
        "k": "step 2 · plant selection",
        "t": "We guide you to the plant that best fits your needs.",
        "d": "DEC Energy proposes a shortlist of active renewable plants owned by third-party producers, with specific technology, geography and energy-sales characteristics."
      },
      {
        "k": "step 3 · contract activation",
        "t": "Sign the multi-year agreement and pay a one-off fee.",
        "d": "Once the plant is selected, we support you through the contract negotiation. Only after signing you pay the contract fee in a single payment."
      },
      {
        "k": "step 4 · the results",
        "t": "Receive a share of the revenues and Guarantees of Origin every year.",
        "d": "For the entire duration of the agreement, you receive the Guarantees of Origin and a share of the revenues generated by the energy produced and sold by the contracted plant"
      }
    ],
    "cta": {
      "primary": "Discover the solutions",
      "secondary": "Contact us"
    },
    "schema": {
      "consumi": "Consumption",
      "target": "Target",
      "fotovoltaico": "Photovoltaic",
      "eolico": "Wind",
      "redditoVar": "Variable income",
      "redditoFisso": "Fixed income"
    },
    "slides": {
      "goTitle": "Guarantees of Origin",
      "revenueTitle": "Commercial revenues"
    }
  }
}
